import { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Stack
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import SignInFormModal from "components/siginIn/formModal";
import slackIcon from "assets/slackIcon.svg";
import Intro1 from "assets/intro1.png";
import Intro2 from "assets/intro2.png";
import Intro3 from "assets/intro3.png";
import AppLogo from "assets/login_logo.png";
import AppLogoViolet from "assets/main-logo.svg";
import { useAuthUrls } from "./SignInQueries";
import styles from "./styles";
import ModalComponent from "components/SharedComponents/Modal";
import { useLocation } from "react-router-dom";
import { CustomButton } from "components/SharedComponents/CustomButton";
import { Link } from "react-router-dom";

const SignIn = () => {
  const classes = styles();
  const location = useLocation();
  const {
    data,
    isLoading: isAuthURLsLoading,
    isSuccess
  } = useAuthUrls();

  const initialClass = {
    img1: classes.tutorialImage,
    img2: classes.tutorialImage,
    img3: classes.tutorialImage
  };
  const [imgClasses, setImgClasses] = useState({
    ...initialClass,
    img1: `${classes.tutorialImage} ${classes.fadeInImage}`
  });
  const switchImg = (event: any) => {
    const img = event.target.dataset.img as "img1" | "img2" | "img3";
    const nextState = {
      ...initialClass
    };
    nextState[
      img
    ] = `${classes.tutorialImage} ${classes.fadeInImage}`;
    setImgClasses(nextState);
  };
  const [openBetaFormModal, setOpenBetaFormModal] = useState(false);
  const [openErrorModal, setErrorModal] = useState(false);
  const handleModalClose = () => setOpenBetaFormModal(false);
  const handleErrorModalClose = () => setErrorModal(false);
  const showErrorModal = !!location.state;
  const errorMessage = location.state?.error
    ? location.state.error
    : "";

  useEffect(() => {
    if (showErrorModal) {
      setErrorModal(true);
    }
  }, [showErrorModal]);
  const onSignInClick = () => {};
  return (
    <>
      <Grid
        container
        justifyContent="center"
        className={classes.signInContainer}
      >
        <Grid
          item
          md={6}
          lg={7}
          container
          direction="column"
          justifyContent="center"
          display={{ xs: "none", sm: "none", md: "flex" }}
        >
          <div className={classes.leftGrid}>
            <img
              src={AppLogo}
              className={classes.logo}
              alt="Hoya App"
            />
            <Stack
              direction={"row"}
              sx={{
                position: "absolute",
                overflowX: "hidden",
                left: { xs: "0", lg: "15%" },
                maxWidth: "100vw"
              }}
            >
              <Stack
                sx={{
                  position: "absolute",
                  top: "23%",
                  zIndex: "3"
                }}
              >
                <Button
                  autoFocus
                  disableRipple
                  className={classes.carouselBtn}
                  data-img={"img1"}
                  onClick={switchImg}
                >
                  ⬤
                </Button>
                <Button
                  disableRipple
                  className={classes.carouselMidBtn}
                  data-img={"img2"}
                  onClick={switchImg}
                >
                  ⬤
                </Button>
                <Button
                  disableRipple
                  className={classes.carouselBtn}
                  data-img={"img3"}
                  onClick={switchImg}
                >
                  ⬤
                </Button>
              </Stack>
              <img
                src={Intro1}
                alt="Tutorial 1"
                className={`${imgClasses.img1} ${classes.firstImage}`}
              />

              <img
                src={Intro2}
                alt="Tutorial 2"
                className={imgClasses.img2}
              />
              <img
                src={Intro3}
                alt="Tutorial 3"
                className={imgClasses.img3}
              />
            </Stack>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={5}
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          className={classes.rightGrid}
        >
          <Card className={classes.card}>
            <CardContent className={classes.signInCard}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={0}
              >
                <Grid item>
                  <img
                    className={classes.loginLogo}
                    src={AppLogoViolet}
                    alt="Hoya app"
                  />
                </Grid>
              </Grid>
              <Typography className={classes.signTxt}>
                Sign in or sign up to your Account !
              </Typography>

              <Button
                disabled={isAuthURLsLoading || !isSuccess}
                className={classes.slackUrl}
                onClick={onSignInClick}
                href={data?.slackSigninURL}
              >
                <img
                  alt="Sign in with Slack"
                  className={classes.slackIcon}
                  src={slackIcon}
                />
                Sign in with Slack
              </Button>

              {/* <Typography className={classes.orText}>Or</Typography> */}

              {/* <Button
                disabled={isAuthURLsLoading || !isSuccess}
                className={classes.slackUrl}
                onClick={handleModalOpen}
              >
                <img
                  alt="Add to Slack"
                  className={classes.slackIcon}
                  src={slackIcon}
                />
                Join our beta program
              </Button> */}
              <Typography className={classes.orText}>Or</Typography>
              <Button
                disabled={isAuthURLsLoading || !isSuccess}
                className={classes.slackUrl}
                href={data?.slackAddtoURL}
              >
                <img
                  alt="Add to Slack"
                  className={classes.slackIcon}
                  src={slackIcon}
                />
                Add to Slack
              </Button>
            </CardContent>
          </Card>
          <div className={classes.termsAndConditions}>
            By signing up you accept{" "}
            <Link to="/terms-of-service" className={classes.link}>
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link to="/privacy-policy" className={classes.link}>
              Privacy Policy
            </Link>
          </div>
        </Grid>
      </Grid>

      <SignInFormModal
        open={openBetaFormModal}
        handleClose={handleModalClose}
      />
      <ModalComponent
        openModal={openErrorModal}
        handleClose={handleErrorModalClose}
        bodyStyles={{
          height: "auto",
          width: "auto"
        }}
      >
        <Stack alignItems={"center"}>
          <Typography>{errorMessage}</Typography>
          <CustomButton
            layout="primary"
            sx={{ width: "5rem", marginTop: "0.5rem" }}
            onClick={handleErrorModalClose}
          >
            Ok
          </CustomButton>
        </Stack>
      </ModalComponent>
    </>
  );
};

export default SignIn;
